import axios from '@/request';
import qs from 'qs';

export default {
    async list(params: any) {
        return axios.get('redpacket/list', { params });
    },
}
